<template>
  <div class="page-container">
    <el-page-header @back="$router.go(-1)" content="사용자 화면" />
    <div style="height: 26px"></div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card class="box-card">
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="아이디">
              <el-input v-model="form.mgrid" disabled></el-input>
            </el-form-item>
            <el-form-item label="비밀번호">
              <el-input v-model="form.password" disabled></el-input>
            </el-form-item>
            <el-form-item label="이름">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="이메일">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item label="휴대전화">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="이메일 인증">
                  <el-switch v-model="form.email_auth"></el-switch>
                </el-form-item>
                <el-form-item label="승인프로세스" v-if="form.user_type === 2">
                  <el-switch v-model="policyForm.flag_function_approval"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="정책관리 사용" v-if="form.user_type === 2">
                  <el-switch v-model="policyForm.flag_function_common_policy"></el-switch>
                </el-form-item>
                <el-form-item label="접속IP관리 사용" v-if="form.user_type === 2">
                  <el-switch v-model="policyForm.flag_function_ip_policy"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button type="primary" :loading="loading" @click="onSubmit">변경</el-button>
              <el-button @click="$router.go(-1)">취소</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>  
</template>

<script>
export default {
  props: {
    user_pk: {
      type: [Number, String],
      required: true
    }
  },
  methods: {
    async getUser () {
      let {data} = await this.$http.get(`users/${this.user_pk}`)
      data.email_auth = !!data.email_auth
      this.form = data
      
      let policy = await this.$http.get(`company_function/${this.user_pk}`)
      let policyData = policy.data[0]
      this.policyForm = policyData

      return data
    },
    async onSubmit() {
      let {name, email, phone, email_auth} = this.form
      let {flag_function_approval, flag_function_common_policy, flag_function_ip_policy} = this.policyForm
      let pk = this.user_pk
      if (!name || !/^[a-zA-Z0-9가-힣]+$/.test(name)) {
        this.$service.$emit('alert-modal', '올바른 이름을 입력해 주세요.')
        this.loading = false
        return;
      }
      if (phone && !/^[0-9-]+$/.test(phone)) {
        this.$service.$emit('alert-modal', '전화번호에 허용되지 않는 문자가 포함되어 있습니다.')
        this.loading = false
        return;
      }
      try {
        let params = {name, email, phone, email_auth}
        let {data} = await this.$http.put(`users/${this.user_pk}`, params)

        let policyParams = {pk, flag_function_approval, flag_function_common_policy, flag_function_ip_policy}
        let {policyData} = await this.$http.put('company_function', policyParams)

        this.loading = false
        this.$service.$emit('alert-modal', '사용자 정보 변경에 성공했습니다.')
      }
      catch (e) {
        console.error(e)
        this.$service.$emit('alert-modal', '변경에 실패했습니다. 다시 시도해 주세요.')
        this.loading = false
      }
    }
  },
  mounted () {
    this.getUser()
  },
  data () {
    return {
      loading: false,
      form: {},
      policyForm: {}
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
